import { type FC } from 'react';
import { type ColorlessIconProps, IconDocument, IconFolder, IconLink, IconTag } from '@direct-frontend/components';
import { type OpenApiSchemaMenuLinkType } from '#shared/api/schema';

export const MenuItemLinkTypeIcon: Record<OpenApiSchemaMenuLinkType, FC<ColorlessIconProps>> = {
    category: IconFolder,
    page: IconDocument,
    external: IconLink,
    collection: IconTag,
};
